import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class LeftyRighty extends Component {
    static propTypes = {
        direction: PropTypes.oneOf(["left", "right"]),
        theme: PropTypes.oneOf(["light", "dark"]),
        url: PropTypes.string.isRequired,
        title: PropTypes.string,
        subtitle: PropTypes.string,
        text: PropTypes.string,
        button: PropTypes.string,
        desc: PropTypes.arrayOf(
            PropTypes.shape({
                label: PropTypes.string,
                content: PropTypes.string
            })
        ),
        imageUrl: PropTypes.string,
        caption: PropTypes.string
    };

    static defaultProps = {
        direction: "left",
        theme: "dark",
        button: "Learn more"
    };

    render() {
        const {
            direction,
            theme,
            url,
            title,
            subtitle,
            text,
            button,
            desc,
            imageUrl,
            caption
        } = this.props;

        return (
            <div
                className={classNames(
                    "lefty-righty",
                    `lefty-righty--${direction}`,
                    `lefty-righty--${theme}`
                )}
            >
                <div className="lefty-righty__image">
                    <a
                        className="lefty-righty__image-hover"
                        href={url}
                        aria-label={title}
                    >
                        <div className="lefty-righty__image-wrap">
                            <div
                                className="lefty-righty__image-front"
                                style={{
                                    backgroundImage: `url(${imageUrl})`
                                }}
                            />
                            <div className="lefty-righty__image-underlay" />
                        </div>

                        {caption && (
                            <div className="lefty-righty__image-caption">
                                {caption}
                            </div>
                        )}
                    </a>
                </div>
                <div className="lefty-righty__content">
                    {subtitle && (
                        <div className="lefty-righty__sub-title">
                            {subtitle}
                        </div>
                    )}

                    <div className="lefty-righty__title">
                        <h3>{title}</h3>
                    </div>

                    <div className="lefty-righty__text">
                        <p className="small">{text}</p>
                    </div>

                    {desc &&
                        desc.length > 0 && (
                            <div className="lefty-righty__desc">
                                <table>
                                    <tbody>
                                        {desc.map(({ label, value }) => (
                                            <tr key={label}>
                                                <td>{label}:</td>
                                                <td>{value}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                    <div className="lefty-righty__button">
                        <a
                            className={classNames(
                                "button",
                                "button--hollow",
                                `button--${theme}`
                            )}
                            href={url}
                        >
                            {button}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

export default LeftyRighty;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/LeftyRighty.js